import React, { useEffect, useRef } from "react"
import { gsap } from "gsap"
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io"
import PropTypes from "prop-types"

import {
  animationSettings,
  progressSettings,
  totalCycle,
  years,
} from "../../../services/timelineService"


import SampleYear from "./SampleYear"
const Progress = (props) => {
  const progressRef = useRef(null)

  let { scrubTo, sampleData } = props
  useEffect(() => {
    console.log(
      'from width: ',(window.innerWidth / years.length) * props.currentSegment,' to width: ',(window.innerWidth / years.length) * (props.currentSegment + 1), ' duration: ',parseFloat(sampleData.years[years[props.currentSegment]].heroVideo.duration)
    )
    gsap.fromTo(
      progressRef.current,
      {
        width: `${(window.innerWidth / years.length) * props.currentSegment}px`, //+ // do this as a % instead of px
        // window.innerWidth / years.length / 2, //# segments + 1/2 segment
      },
      {
        width: `${(window.innerWidth / years.length) * (props.currentSegment + 1)}px`, // +
        // window.innerWidth / years.length / 2,
        duration:
          parseFloat(sampleData.years[years[props.currentSegment]].heroVideo.duration), //+
          // totalCycle(),
        ease: "none",
      }
    )
  }, [props.currentSegment])

  const yearList = years.map((ea, i) => {
    return (
      <SampleYear
        key={`year-${ea}-${i}`}
        width={100 / years.length}
        year={ea}
        animationSettings={animationSettings}
        scrubTo={scrubTo}
        active={ea === years[props.currentSegment]}
      />
    )
  })

  return (
    <>
      <div id='progress-bar__indicator' ref={progressRef}></div>
      <div id='progress-year-container'>
        {yearList}
      </div>
    </>
  )
}

Progress.propTypes = {
  progressTl: PropTypes.object,
  scrubTo: PropTypes.func,
  sampleData: PropTypes.object,
  currentSegment: PropTypes.number,
}

export default Progress
